import { useCallback, useState } from 'react';
import { $usersStore } from '@lib/store/userManagement';
import type { UserWithPaymentInfo } from '@shared/api/rest/users';
import { UserItemHead } from './userItemHead';
import { UserContacts } from './userContacts';
import { UserLongInfo } from './userLongInfo';
import { ShortInfo } from './shortInfo';
import { AddAccountsModal, AddCardsModal } from '@widgets';

export interface IUserProps {
  user: UserWithPaymentInfo;
}

export const User = (props: IUserProps) => {
  const [showUserLongInfo, setShowUserLongInfo] = useState<boolean>(false);
  const [showAddAccounts, setShowAddAccounts] = useState<boolean>(false);
  const [showAddCards, setShowAddCards] = useState<boolean>(false);

  const removeAccount = useCallback(
    (id: number) => {
      $usersStore.events.removeAccount({
        userIds: props.user.id,
        accountIds: [id],
      });
    },
    [props.user.id],
  );
  const removeCard = useCallback(
    (id: number) => {
      $usersStore.events.removeCard({
        userIds: props.user.id,
        cardIds: [id],
      });
    },
    [props.user.id],
  );

  return (
    <div>
      <div className='min-w-[300px] rounded-lg bg-white dark:bg-soft-black relative'>
        <div>
          <UserItemHead user={props.user} open={showUserLongInfo} setOpen={() => setShowUserLongInfo(!showUserLongInfo)} />
          {showUserLongInfo ? (
            <div className='w-full max-h-[300px] rounded-b-lg bg-white dark:bg-soft-black overflow-auto  z-50 no-scrollbar'>
              <UserContacts user={props.user} />
              <UserLongInfo
                openAddAccount={() => setShowAddAccounts(true)}
                openAddCard={() => setShowAddCards(true)}
                removeAccount={removeAccount}
                removeCard={removeCard}
                userId={props.user.id}
                accounts={props.user.accounts}
                cards={props.user.cards}
                type={props.user.userType}
                locked={props.user.locked}
                open={showUserLongInfo}
              />
            </div>
          ) : (
            <ShortInfo type={props.user.userType} locked={props.user.locked} cards={props.user.cards.length} accounts={props.user.accounts.length} />
          )}
        </div>
        <AddAccountsModal
          isOpen={showAddAccounts}
          user={props.user}
          accountsItems={props.user.accounts}
          onClose={() => setShowAddAccounts(false)}
          onSubmit={(data) => $usersStore.events.addAccount(data)}
        />
        <AddCardsModal
          isOpen={showAddCards}
          user={props.user}
          cardsItems={props.user.cards}
          onClose={() => setShowAddCards(false)}
          onSubmit={(data) => $usersStore.events.addCard(data)}
        />
      </div>
    </div>
  );
};
